import { styled } from '@mui/material/styles';

const StyledPasswordBox = styled('div')`
  .divider {
    height: 28px;
    background-color: #1e164e29;
  }

  .MuiTextField-root {
    border-radius: 8px;
    color: #1c1c1e7a !important;
  }

  .MuiOutlinedInput-root {
    color: #1c1c1e7a !important;
    font-size: 14px !important;
    height: 40px !important;
    border-radius: 8px !important;
  }
`;

export { StyledPasswordBox };
